import { Asterisk } from "lucide-react";

const PHRASES = [
  "LOCALIZED DISCOVERY",
  "COMMUNITY ENGAGEMENT",
  "DYNAMIC PRICING",
  "SPONTANEOUS DISCOVERY",
  "SOCIAL-FIRST TICKETING",
  "THE LOCAL PULSE",
];

const Marquee = () => (
  <div data-testid="corporate-ticker" className="marquee overflow-hidden bg-charcoal-900 py-5">
    <div className="marquee-track flex w-max items-center">
      {[...PHRASES, ...PHRASES].map((p, i) => (
        <span key={i} className="flex items-center" aria-hidden={i >= PHRASES.length}>
          <span className="whitespace-nowrap font-mono text-xs font-semibold uppercase tracking-[0.3em] text-slate-400 sm:text-sm">
            {p}
          </span>
          <Asterisk className="mx-8 h-4 w-4 shrink-0 text-accent sm:mx-12" />
        </span>
      ))}
    </div>
  </div>
);

export default Marquee;
